/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u3m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing a boxing or kickboxing round at the standard 3-minute length.`)
};

const es_timer_u3m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar un round de boxeo o kickboxing con la duración estándar de 3 minutos.`)
};

const de_timer_u3m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Box- oder Kickbox-Runde in der Standardlänge von 3 Minuten stoppen.`)
};

const nl_timer_u3m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een boks- of kickboksronde timen op de standaardlengte van 3 minuten.`)
};

const fr_timer_u3m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronométrer un round de boxe ou de kickboxing à la durée standard de 3 minutes.`)
};

const it_timer_u3m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrare un round di boxe o kickboxing alla durata standard di 3 minuti.`)
};

const pt_br2_timer_u3m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar um round de boxe ou kickboxing na duração padrão de 3 minutos.`)
};

const pt_timer_u3m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar um assalto de boxe ou kickboxing na duração padrão de 3 minutos.`)
};

const ja_timer_u3m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準的な3分の長さでボクシングやキックボクシングのラウンドを計測する。`)
};

const zh_timer_u3m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为拳击或踢拳比赛回合计时，标准时长为3分钟。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u3m_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u3m_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u3m_use3", locale)
	if (locale === "en") return en_timer_u3m_use3(inputs)
	if (locale === "es") return es_timer_u3m_use3(inputs)
	if (locale === "de") return de_timer_u3m_use3(inputs)
	if (locale === "nl") return nl_timer_u3m_use3(inputs)
	if (locale === "fr") return fr_timer_u3m_use3(inputs)
	if (locale === "it") return it_timer_u3m_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u3m_use3(inputs)
	if (locale === "pt") return pt_timer_u3m_use3(inputs)
	if (locale === "ja") return ja_timer_u3m_use3(inputs)
	return zh_timer_u3m_use3(inputs)
};